<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="Confirm" lazy-validation>
          <v-card class="elevation-12">
            <v-card-title primary-title class="primary">
              <div class="headline white--text">Set New Password</div>
            </v-card-title>
            <v-card-text>
              <p>
                You are required to reset your password. If you have not received a code, please fill out your username
                and click "Request Code" to request a new one.
              </p>
            </v-card-text>
            <v-card-text>
              <v-text-field
                autocomplete="username"
                prepend-icon="person"
                name="username"
                label="Username"
                :rules="nameRules"
                :disabled="loading"
                v-model="user.username"
                type="text">
              </v-text-field>
              <v-text-field
                v-model="user.code"
                :disabled="loading"
                prepend-icon="person"
                name="code"
                label="Code"
                type="text"
              ></v-text-field>
              <v-text-field
                autocomplete="new-password"
                id="newPassword"
                prepend-icon="lock"
                name="newPassword"
                label="New Password"
                :rules="passwordRules"
                :disabled="loading"
                v-model="user.newPassword"
                type="password">
              </v-text-field>
              <router-link to="SignIn">Login</router-link>&nbsp;
              <router-link to="ForgotPassword">Forgot Password</router-link>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                @click="RequestCode"
                :loading="loading"
                type="submit"
                :disabled="!this.user.username">
                Request Code
              </v-btn>
              <v-btn
                color="primary"
                @click="Confirm"
                :loading="loading"
                type="submit">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'ConfirmSignUp',
    data() {
      return {
        loading: false,
        nameRules: [
          (v) => !!v || 'Username ist ein Pflichtfeld',
          (v) => (v && v.length <= 10) || 'Username must be less than 10 characters',
        ],
        passwordRules: [
          (v) => !!v || 'Passwort ist ein Pflichtfeld',
        ],
        user: {
          username: null,
          oldPassword: null,
          newPassword: null,
        },
      };
    },
    computed: {
      ...mapGetters({
        username: 'guest/auth/username',
        oldPassword: 'guest/auth/oldPassword',
      }),
    },
    methods: {
      ...mapActions({
        forgotPassword: 'guest/auth/forgotPassword',
        forgotPasswordSubmit: 'guest/auth/forgotPasswordSubmit',
        showSnackbar: 'common/snackbar/success',
      }),
      Confirm(e) {
        e.preventDefault();
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.forgotPasswordSubmit(this.user)
            .then((res) => {
              this.loading = false;
              if (res) {
                this.showSnackbar('New Password set, you can log in now');
                this.$router.push({name: 'SignIn'});
              }
            });
        }
      },
      RequestCode(e) {
        e.preventDefault();
        if (this.user.username) {
          this.loading = true;
          this.forgotPassword(this.user)
            .then((res) => {
              this.loading = false;
              if (res) {
                this.showSnackbar('Code sent, please check you mail');
              }
            });
        }
      },
    },
    mounted() {
      if (this.username) {
        this.user.username = this.username;
      }
      if (this.oldPassword) {
        this.user.oldPassword = this.oldPassword;
      }
    },
  };
</script>

<style scoped>

</style>
